import { ILinkedDropdownFieldConfigurationClient, ILinkedDropdownFieldConfigurationServer } from "./interface";
import { FieldProps } from "../FormFieldSelector/interfaces";
import {
    IFieldSubmissionMap,
    IFormFieldSubmission,
} from "@common/redux/formSubmission/interface";
import { validateRule } from "../FormTextInputField/rules/utils";


export const parseTextareaData = (input: string) => {
    const lines = input.split('\n') || [];
    const result = [];
    const stack = [];

    lines?.forEach(line => {
        const trimmedLine = line?.trim();
        if (!trimmedLine) return null;
        const indentation = line?.match(/^\s*/)[0]?.length;
        const node = { [trimmedLine]: {} };
        while (stack.length && stack[stack.length - 1].indentation >= indentation) {
            stack.pop();
        }
        if (stack.length === 0) {
            result.push(node);
        } else {
            const parent = stack[stack.length - 1].node;
            const parentKey = Object.keys(parent)[0];
            parent[parentKey][trimmedLine] = {};
        }
        stack.push({ node, indentation });
        if (stack.length > 1) {
            const parentNode = stack[stack.length - 2].node;
            const parentKey = Object.keys(parentNode)[0];
            parentNode[parentKey][trimmedLine] = node[trimmedLine];
        }
    });
    return result;
};

export const convertToText = (data: any, level: number = 0): string => {
    let text = '';
    for (let key in data) {
        if (data.hasOwnProperty(key)) {
            text += ' '.repeat(level * 4) + key + '\n';
            if (typeof data[key] === 'object' && Object.keys(data[key]).length > 0) {
                text += convertToText(data[key], level + 1);
            }
        }
    }
    return text;
};

export const transformLinkedDropdownFieldConfigClientToServer = (fieldConfigClient: any): ILinkedDropdownFieldConfigurationServer => {
    const { linkedValues } = fieldConfigClient;

    const fieldConfigServer = {
        linkedValues: linkedValues
    };
    return fieldConfigServer;
};

export const transformLinkedDropdownConfigServerToClient = (fieldConfigServer: any): ILinkedDropdownFieldConfigurationClient => {
    const { linkedValues } = fieldConfigServer;
    const fieldConfigClient = {
        linkedValues: linkedValues
    };
    return fieldConfigClient;
};


export const validatelinkedDropdownFieldSubmissionData = (
    fieldEditConfig: FieldProps,
    fieldSubmissionData: IFormFieldSubmission,
    fieldSubmissionMap: IFieldSubmissionMap
): [boolean, string] => {
    const { isRequired, rules: fieldRules } = fieldEditConfig;
    const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;

    const submissionValue =
        (fieldSubmissionValue && fieldSubmissionValue?.value) || "";

    if (fieldRules && submissionValue) {
        for (let i = 0; i < fieldRules?.length; i++) {
            const [isValidated, validatationErrorMessage] = validateRule(
                fieldRules[i],
                submissionValue,
                fieldSubmissionMap
            );
            if (!isValidated && validatationErrorMessage != "") {
                return [isValidated, validatationErrorMessage];
            }
        }
    }

    if (isRequired) {
        if (!submissionValue) {
            return [false, "field is required"];
        }
    }
    return [true, ""];
};